 /**
 * v-hasPermi 操作权限处理
 * Copyright (c) 2019 ruoyi
 */
import { findIndex } from 'lodash';
import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const permissions =  store.getters && store.getters.permissionsList;
    
    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value;
      const permissionList = permissions || [];
      const hasPermissions = permissionList.some(permission => {
        return permissionFlag.includes(permission)
      })
      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  },
  // 手动判断是否有权限,结合V-if 和 v-show 使用,解决第三方组件自定义指令removeChild不生效问题
  insertedHandler(value){
    const permissions =  store.getters && store.getters.permissionsList;
    
    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value;
      const permissionList = permissions || [];
      const hasPermissions = permissionList.some(permission => {
        return permissionFlag.includes(permission)
      })
    
      return hasPermissions
    } else {
      console.log('没有该权限',value)
    }
  }
}



